import { render, staticRenderFns } from "./layout-options-fallback.vue?vue&type=template&id=5a26ec37&"
import script from "./layout-options-fallback.vue?vue&type=script&lang=js&"
export * from "./layout-options-fallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "layout-options-fallback.vue"
export default component.exports